import { Text } from '_/space-management/components';
import { colors } from '_/space-management/constants/theme';
import { useSlotContext } from '_/space-management/hooks/SlotContext';
import { useSpaceContext } from '_/space-management/hooks/SpaceContext';
import { SlotsModel } from '_/space-management/services/models/slots.model';
import React from 'react';
import { TouchableOpacity } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import { AppRoute } from '_/space-management/navigation/types';
import { useTranslation } from 'react-i18next';
import styles from './styles';

export interface SlotProps {
  slot: SlotsModel;
}

export default function Slot({ slot }: SlotProps) {
  const { setIsSlotModalVisible } = useSlotContext();
  const { spaceType, currentSpace } = useSpaceContext();
  const navigation = useNavigation<any>();
  const { t } = useTranslation();

  return (
    <>
      <TouchableOpacity
        style={styles(spaceType, slot.isAvailable).slot}
        activeOpacity={slot.isAvailable ? 0.2 : 1}
        onPress={() => {
          if (!slot.isAvailable) return;
          
          if (currentSpace.scheduleEnabled) {
            navigation.navigate(AppRoute.SLOT_SCHEDULE, { slot });
          } else {
            setIsSlotModalVisible(slot.id);
          }
        }}
      >
        <Text
          fontSize={16}
          fontType="medium"
          style={styles(spaceType, slot.isAvailable).slotName}
          numberOfLines={3}
        >
          {slot.name}
        </Text>
        {slot.responsibleMember && (
          <Text
            fontSize={12}
            color={colors.midGrey}
            fontType="medium"
            style={{ padding: 1, marginTop: 4 }}
            numberOfLines={1}
          >
            {t('responsible')}: {slot.responsibleMember.name}
          </Text>
        )}
      </TouchableOpacity>
    </>
  );
}
